import { ButtonProps } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import googleIcon from '@/assets/images/google.svg';
import { StyledButton, StyledImage } from './LoginButton.styles';
import { NAMESPACE } from '@/constants';

export const LoginButton: FC<ButtonProps> = (props) => {
  const { t } = useTranslation(NAMESPACE.LOGIN_PAGE);

  return (
    <StyledButton
      type="default"
      icon={<StyledImage wrapperClassName="anticon" src={googleIcon} preview={false} />}
      {...props}
    >
      <span>{t('logInWithGoogle')}</span>
    </StyledButton>
  );
};

export default LoginButton;
